import React, { useEffect } from "react";
import { Flex } from "rebass";
import { MainLayout } from "../layouts/MainLayout";
import { yodaInfoActions } from "../logic/actions/yodaInfo.actions";
import { useDispatch, useSelector } from "react-redux";
import { stringHtmlConverter } from "../utils/stringHtmlConverter";

const PrivacyPage = () => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const dispatch = useDispatch();
  const { privacy } = useSelector((state) => state.yodaInfo);

  useEffect(() => {
    dispatch(yodaInfoActions.getPrivacy());
  }, []);

  useEffect(() => {
    document
      .getElementById("idDiv")
      .appendChild(
        stringHtmlConverter(
          lang === "it"
            ? privacy?.content?.it || ""
            : privacy?.content?.en || "",
        ),
      );
  }, [privacy]);

  return (
    <MainLayout client>
      <Flex width={1} flexDirection="column" p={4}>
        <div
          id={"idDiv"}
          className="b-content_asset b-content_asset--privacy-policy content-asset"
        ></div>
      </Flex>
    </MainLayout>
  );
};

export { PrivacyPage };
